import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { Input } from '@progress/kendo-react-inputs';
import { FormFieldWrapper, FormFieldWrapperProps } from '../FormFieldWrapper';

interface FormInputFieldProps extends FieldRenderProps {
  min?: number;
  max?: number;
  isLoading?: boolean;
  showRefreshButton?: boolean;
  onRefresh?: (value: unknown) => void;
  renderFieldWrapper?: (props: FormFieldWrapperProps) => React.ReactNode;
}

export const FormInput: React.FC<FormInputFieldProps> = fieldRenderProps => {
  const { min, max, disabled, isLoading, showRefreshButton, onRefresh, renderFieldWrapper } = fieldRenderProps;

  const inputElement = (
    <Input
      name={fieldRenderProps.name}
      valid={fieldRenderProps.valid}
      value={fieldRenderProps.value}
      defaultValue={fieldRenderProps.defaultValue}
      onChange={fieldRenderProps.onChange}
      label={undefined}
      labelClassName={fieldRenderProps.labelClassName}
      validationMessage={fieldRenderProps.validationMessage || undefined}
      minLength={min}
      maxLength={max}
      disabled={disabled}
    />
  );

  const wrapperProps: FormFieldWrapperProps = {
    validationMessage: fieldRenderProps.validationMessage,
    value: fieldRenderProps.value,
    touched: fieldRenderProps.touched,
    id: fieldRenderProps.id,
    valid: fieldRenderProps.valid,
    disabled: fieldRenderProps.disabled,
    hint: fieldRenderProps.hint,
    label: fieldRenderProps.label,
    wrapperStyle: fieldRenderProps.wrapperStyle,
    optional: fieldRenderProps.optional,
    modified: fieldRenderProps.modified,
    visited: fieldRenderProps.visited,
    onChange: fieldRenderProps.onChange,
    onFocus: fieldRenderProps.onFocus,
    onBlur: fieldRenderProps.onBlur,
    name: fieldRenderProps.name,
    isLoading,
    showRefreshButton,
    onRefresh: () => onRefresh?.(fieldRenderProps.value),
    children: inputElement
  };

  if (renderFieldWrapper) {
    return renderFieldWrapper(wrapperProps);
  }

  return (
    <FormFieldWrapper
      validationMessage={wrapperProps.validationMessage}
      value={wrapperProps.value}
      touched={wrapperProps.touched}
      id={wrapperProps.id}
      valid={wrapperProps.valid}
      disabled={wrapperProps.disabled}
      hint={wrapperProps.hint}
      label={wrapperProps.label}
      wrapperStyle={wrapperProps.wrapperStyle}
      optional={wrapperProps.optional}
      modified={wrapperProps.modified}
      visited={wrapperProps.visited}
      onChange={wrapperProps.onChange}
      onFocus={wrapperProps.onFocus}
      onBlur={wrapperProps.onBlur}
      name={wrapperProps.name}
      isLoading={wrapperProps.isLoading}
      showRefreshButton={wrapperProps.showRefreshButton}
      onRefresh={wrapperProps.onRefresh}
    >
      {inputElement}
    </FormFieldWrapper>
  );
};
